import { type FC } from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text
} from '@cencosud-cencommerce/paris-uikit';

import { BuyNowEventInteractiveTags } from '@/modules/shared/utils/gtmEvents/buyNowTypes';
import { sendEvent } from '@/modules/shared/utils/gtmEvents/sendEvents/sendBuyNowEvents';
import { useMergeFastCheckoutCart } from '@/Pages/BuyNowPage/hooks/useMergeFastCheckoutCart';

interface CardPaymentProps {
  isOpen: boolean;
  onClose: () => void;
  loading?: boolean;
}

const OTHER_PAYMENT_METHODS_MESSAGE =
  'Para una compra rápida usaremos tus tarjetas guardadas. Si quieres elegir otro medio de pago o Gift card, ';
const GO_TO_CART_MESSAGE = 'puedes hacerlo desde el carro.';
const BACK_BUTTON_LABEL = 'Volver';
const GO_TO_CART_BUTTON_LABEL = 'Ir al carro';

const CardPaymentModal: FC<CardPaymentProps> = ({
  isOpen,
  onClose,
  loading
}) => {
  const { mergeAndRedirectToCart } = useMergeFastCheckoutCart();

  return (
    <Modal size="sm" isOpen={isOpen} onClose={onClose}>
      <ModalHeader
        icon={{
          name: 'il-payment-methods'
        }}
        className="[&_h3]:co-text-[0.875rem] tablet:[&_h3]:co-text-[1.25rem]"
        onClose={onClose}
        title="Otros medios de pago"
      />
      <ModalBody className="co-flex co-flex-col co-gap-4 tablet:co-min-h-[244px]">
        <div className="co-flex co-flex-col co-h-500px">
          <div className="co-pt-[8px] co-h-500px">
            <Text variant="body2" weight={400} className="co-h-500px">
              {OTHER_PAYMENT_METHODS_MESSAGE}
            </Text>
            <Text variant="body2" weight={600}>
              {GO_TO_CART_MESSAGE}
            </Text>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="co-flex co-flex-col-reverse tablet:co-flex-row co-justify-end co-gap-2 [&>*]:co-w-full tablet:[&>*]:co-w-fit">
        <Button block size="xl" variant="secondary" onClick={onClose}>
          {BACK_BUTTON_LABEL}
        </Button>
        <Button
          size="xl"
          variant="primary"
          loading={loading}
          iconLeft="shopping-cart"
          onClick={() => {
            sendEvent({
              event: 'baseEvent',
              extraFields: {
                'event-interactive-tag':
                  BuyNowEventInteractiveTags.PaymentMethodsGoToCart
              }
            });
            mergeAndRedirectToCart();
          }}
        >
          {GO_TO_CART_BUTTON_LABEL}{' '}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CardPaymentModal;
